"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _reduxForm = require("redux-form");

var _Component = _interopRequireDefault(require("./Component"));

var FORM_NAME = 'exchange-create';

var validate = function validate(values) {
  var errors = {};

  if (!values['shop']) {
    errors['shop'] = 'Обязательное поле';
  }

  if (!values['description']) {
    errors['description'] = 'Обязательное поле';
  } else if (values['description'].length > 1000) {
    errors['description'] = 'Не более 1000 знаков';
  } else if (/(\b|\D)([456]([-\s]*\d){15,18})(\b|\D)/img.test(values['description'])) {
    errors['description'] = 'Не указывайте номер карты в описании';
  }

  if (values['shop']) {
    if (!values['sell-amount']) {
      errors['sell-amount'] = 'Обязательное поле';
    } else if (!/^\d+(\.\d{1,2})?$/.test(values['sell-amount'])) {
      // eslint-disable-next-line
      errors['sell-amount'] = 'Неверный формат суммы';
    } else if (Number(values['sell-amount']) <= 0) {
      errors['sell-amount'] = 'Сумма должна быть больше 0';
    } else if (values['shop']['accounts'][values['sell-currency']]) {
      if (Number(values['sell-amount']) > Number(values['shop']['accounts'][values['sell-currency']]['available'])) {
        errors['sell-amount'] = 'Сумма продажи превышает доступный баланс';
      }
    }
  }

  if (!values['buy-amount']) {
    errors['buy-amount'] = 'Обязательное поле';
  } else if (!/^(\d+)(\.\d{1,2})?$/.test(values['buy-amount'])) {
    // eslint-disable-next-line
    errors['buy-amount'] = 'Неверный формат суммы';
  } else if (Number(values['buy-amount']) <= 0) {
    errors['buy-amount'] = 'Сумма должна быть больше 0';
  }

  return errors;
};

var _default = (0, _reduxForm.reduxForm)({
  form: FORM_NAME,
  validate: validate
})(_Component["default"]);

exports["default"] = _default;